import "../assets/sass/main.scss"

import BookingPage from "./modules/BookingPage"
import GoogleMap from "./modules/GoogleMap"
import ContactCards from "./modules/ContactCards"
import CtaBanner from "./modules/CtaBanner"
import FaqAccordion from "./modules/FaqAccordion"
import HealthJourney from "./modules/HealthJourney"
import CategoryArchive from "./modules/CategoryArchive"
import Login from "./modules/Login"
import Navigation from "./modules/Navigation"
import PricingCard from "./modules/PricingCard"
import ServicesGrid from "./modules/ServicesGrid"
import SingleGallery from "./modules/SingleGallery"
import TeamCards from "./modules/TeamCards"
import Testimonials from "./modules/Testimonials"
import ThumbnailSlider from "./modules/ThumbnailSlider"
import WhyChooseUs from "./modules/WhyChooseUs"
import Search from "./modules/Search"
import domReady from "./utils/domReady"
import hasElement from "./utils/hasElement"

const initNavigation = () => {
	if (!hasElement(".menu-toggle") || !hasElement(".nav-links")) {
		return
	}

	new Navigation()
}

const initGoogleMap = () => {
	if (!hasElement(".acf-map")) {
		return
	}

	new GoogleMap()
}

const initContactCards = () => {
	if (!hasElement(".contact-card")) {
		return
	}

	new ContactCards()
}

const initCtaBanner = () => {
	if (!hasElement(".cta-banner")) {
		return
	}

	new CtaBanner()
}

const initFaqAccordion = () => {
	if (!hasElement("[data-faqs-accordion]")) {
		return
	}

	new FaqAccordion()
}

const initHealthJourney = () => {
	if (!hasElement(".health-journey") && !hasElement(".healthJourneySlider")) {
		return
	}

	new HealthJourney()
}

const initCategoryArchive = () => {
	if (!hasElement(".category-archive .blog-card")) {
		return
	}

	new CategoryArchive()
}

const initLogin = () => {
	if (!hasElement(".login form")) {
		return
	}

	new Login()
}

const initPricingCard = () => {
	if (!hasElement(".pricing-card")) {
		return
	}

	new PricingCard()
}

const initServicesGrid = () => {
	if (!hasElement(".service-card")) {
		return
	}

	new ServicesGrid()
}

const initTeamCards = () => {
	if (!hasElement(".team-card")) {
		return
	}

	new TeamCards()
}

const initTestimonials = () => {
	if (!hasElement(".testimonial-card")) {
		return
	}

	new Testimonials()
}

const initThumbnailSlider = () => {
	if (!hasElement(".service-slider")) {
		return
	}

	new ThumbnailSlider()
}

const initWhyChooseUs = () => {
	if (!hasElement(".why-card")) {
		return
	}

	new WhyChooseUs()
}

const initSearch = () => {
	if (!hasElement(".search-btn")) {
		return
	}

	new Search()
}

const initBookingPage = () => {
	if (!hasElement("[data-booking-page]")) {
		return
	}

	new BookingPage()
}

const initSingleGallery = () => {
	if (!hasElement("[data-gallery-preview-item]")) {
		return
	}

	new SingleGallery()
}

const initModules = () => {
	initNavigation()
	initGoogleMap()
	initContactCards()
	initCtaBanner()
	initFaqAccordion()
	initHealthJourney()
	initCategoryArchive()
	initLogin()
	initPricingCard()
	initServicesGrid()
	initSingleGallery()
	initTeamCards()
	initTestimonials()
	initThumbnailSlider()
	initWhyChooseUs()
	initSearch()
	initBookingPage()
}

domReady(initModules)
